getMultiplePmUserNodeInfo